(function () {
  if (window.__productVariantDimensionsInit) return;
  window.__productVariantDimensionsInit = true;

  function getDimensions(data, variantId) {
    if (!data) return '';
    const variantEntry = data.variants.find((v) => v.id === variantId);
    const variantDimensions = (variantEntry?.dimensions || '').trim();
    if (variantDimensions) return variantDimensions;
    return (data.productFallback || '').trim();
  }

  function updateDimensionsContainers(variant) {
    if (!variant) return;
    document.querySelectorAll('[data-product-dimensions]').forEach((container) => {
      const dataEl = container.querySelector('[data-variant-dimensions-json]');
      const valueEl = container.querySelector('[data-product-dimensions-value]');
      if (!dataEl || !valueEl) return;

      let data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch {
        return;
      }

      valueEl.textContent = getDimensions(data, variant.id);
    });
  }

  document.addEventListener('theme:variant:change', (event) => {
    updateDimensionsContainers(event.detail?.variant);
  });
})();
